module.exports = __webpack_public_path__ + "static/4-41599fb341d149e7ae267ac34a6e64bb.jpg";